import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../Reducers/AuthSlice";
import productReducer from "../Reducers/ProductSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productReducer,
  }
});